/**
 * Milliseconds from any shape a stored time arrives in — a Firestore
 * Timestamp (client or admin), a `{ seconds }` / `{ _seconds }` object, an
 * ISO string or a Date — and 0 for none or an unreadable one. Pure.
 */
export const timestampMillis = (t) => {
  if (!t) return 0;
  if (typeof t.toMillis === 'function') return t.toMillis();
  if (typeof t.toDate === 'function') return t.toDate().getTime();
  if (typeof t.seconds === 'number') return t.seconds * 1000;
  if (typeof t._seconds === 'number') return t._seconds * 1000;
  if (typeof t === 'string' || t instanceof Date) {
    const ms = new Date(t).getTime();
    return Number.isNaN(ms) ? 0 : ms;
  }
  return 0;
};
